
import { Component, OnInit, Output, EventEmitter, Inject, Input } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';

@Component({
    selector: 'app-generic-confirm',
    templateUrl: './generic-confirm.component.html',
    styleUrls: ['./generic-confirm.component.scss']
})
export class GenericConfirmComponent implements OnInit {

    @Output() confirmationResult = new EventEmitter<boolean>();
    @Input() message: string;

    constructor(private popoverRef: PopoverRef<any>) {
    }

    ngOnInit(): void {
        if (!this.message && this.popoverRef.data && this.popoverRef.data.message) {
            this.message = this.popoverRef.data.message;
        }
        if (!this.message) {
            this.message = 'Are you sure?';
        }
    }

    close(result: boolean = false) {
        this.confirmationResult.emit(result);
        this.popoverRef.close(result);
    }

    yesClicked() {
        this.close(true);
    }

    noClicked() {
        this.close(false);
    }
}
